export const DAYS_180 = 24 * 3600000 * 180;

export const NOTIFICATION_DELAY = {
  fast: 5000,
  normal: 10000,
  slow: 20000,
};
